const _openModalBtn = $('#js-openModalBtn')
const _closeModalBtn = $('#js-closeModalBtn')
const _searchArea = $('#js-searchArea')
_openModalBtn.click(function(){
	_searchArea.toggleClass('is-show')
})
_closeModalBtn.click(function(){
	_searchArea.toggleClass('is-show')
})
